import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '~/apis/auth';

import { GET_PROFILE, LOGIN } from '~/utils/constants/actionType';
import { IBodyLogin } from '~/utils/interface/auth';

export const handleLogin = createAsyncThunk(
  LOGIN,
  async (
    payload: {
      body: IBodyLogin;
    },
    { rejectWithValue }
  ) => {
    try {
      const resp = await authApi.login(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProfile = createAsyncThunk(GET_PROFILE, async (payload: string, { rejectWithValue }) => {
  try {
    // const resp = await authApi.getProfile(payload);
    // return resp.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
